<div class="errors">
  <p>
    {{
      'csvImports.question.importedQuestionsInfo.message'
        | translate
          : {
              success: data?.total - data?.questions.length,
              failed: data?.questions.length
            }
    }}
  </p>
  <p>
    {{
      'csvImports.question.importedQuestionsInfo.failedQuestionNo' | translate
    }}: {{ failedNum }}
  </p>
  @for (item of data?.questions; track item.index) {
  <div class="csv-item">
    <div class="info">
      <div class="text">
        <div>{{ item.index + 1 }}.&nbsp;&nbsp;</div>
        <span> {{ item.message }}</span>
      </div>
    </div>
  </div>
  }
</div>
<mat-dialog-actions>
  <div class="flex-align-right">
    <button color="primary" mat-button mat-dialog-close type="button">
      {{ 'common.button.ok' | translate }}
    </button>
  </div>
</mat-dialog-actions>
